





















import { Component, Prop, Vue } from 'vue-property-decorator'
import PlaceSelectCount from '@/components/calculator/CalculatorForm/PlaceSelect/PlaceSelectCount.vue'
import Country from '@/dto/deliveries/Country'

@Component({
  components: { PlaceSelectCount },
})
export default class PlaceSelectSearchHint extends Vue {
  @Prop(Object) country: Country
}
